export default (() => {

    function fromString (string) {
        const domParser = new DOMParser();
        const html = domParser.parseFromString(string, 'text/html');

        return html.body.firstElementChild;
    }

    function filterByComponentDirectDescendants (component, elements) {
        if (component === undefined || elements === undefined) {            
            return wealthify.error.throwError('dom.filterByComponentDirectDescendants', 'component and elements must be defined');
        }

        const roots = [...component.querySelectorAll('[data-root]')];
            
        return elements = [...elements].filter(element => roots.filter((root) => root.contains(element)).length === 1);
    }

    function getClosestMatchingParent (child, parentSelector) {
        if (child === undefined || parentSelector === undefined) {            
            return wealthify.error.throwError('dom.getClosestMatchingParent', 'element and parentSelector must be defined');
        }
        
        if (child === null) {
            return null;
        }

        if (child.parentElement === null) {
            return null;
        }
        
        // Start from parent element to exclude child if it matches
        return child.parentElement.closest(parentSelector);
    }

    function getDirectChildren (parent, childSelector) {
        if (parent === undefined || childSelector === undefined) {
            return wealthify.error.throwError('dom.getDirectChildren', 'element and childSelector must be defined');
        }

        if (parent === null) {
            return null;
        }

        return Array.prototype.filter.call(parent.children, (child) => {
            return child.matches(childSelector);
        });
    }

    function isNode (value) {
        return wealthify.type.object.isObject(value) && value.nodeType === 1;
    }

    function isNodeList (value) {
        return wealthify.type.object.isObject(value) &&
            value.nodeType !== 1 &&
            [...value].filter(item => item.nodeType !== 1).length === 0 &&
            [...value].filter(item => item.nodeType === 1).length > 0;
    }

    function isWebComponent (element) {
        return element.tagName.indexOf('-') !== -1;
    }

    function getNodeArrayFromString (string) {
        if (string === undefined) {
            return wealthify.error.throwError('dom.getNodesFromString', 'string must be defined');
        }

        const domParser = new DOMParser();
        const elements = domParser.parseFromString(string, 'text/html');

        return Array.from(elements.body.children);
    }

    function moveContentBetweenNodes (origin, target, includeParent = false) {
        if (origin === undefined || target === undefined) {
            return wealthify.error.throwError('dom.moveContentBetweenNodes', 'origin and target must be defined');
        }

        if (!origin.nodeType || !target.nodeType) {
            return wealthify.error.throwError('dom.moveContentBetweenNodes', 'origin and target must be DOM nodes');
        }

        if (includeParent) {
            target.appendChild(origin);
        } else {
            while (origin.childNodes.length) {
                target.appendChild(origin.childNodes[0]);
            }
        }
    }

    function removeAllParentsChildren (parent) {
        if (parent === undefined) {
            return wealthify.error.throwError('dom.removeAllParentsChildren', 'parentSelector must be defined');
        }

        if (!parent.nodeType) {
            return wealthify.error.throwError('dom.removeAllParentsChildren', 'parentSelector is not a DOM node');
        }

        while (parent.childNodes.length) {
            parent.removeChild(parent.firstChild);
        }
    }

    function removeNodes (nodes) {
        if (nodes === undefined) {
            return wealthify.error.throwError('dom.removeNodes', 'nodes must be defined');
        }

        Array.prototype.forEach.call(nodes, (node) => {
            node.parentElement.removeChild(node);
        });
    }

    function runOnNodeVisible (element, callback) {
        if (element === undefined || callback === undefined) {
            return wealthify.error.throwError('dom.runOnNodeVisible', 'element and callback must be defined');
        }

        if (!element.nodeType) {
            return wealthify.error.throwError('dom.runOnNodeVisible', 'element is not a DOM node');
        }

        if (typeof callback !== 'function') {
            return wealthify.error.throwError('dom.runOnNodeVisible', 'callback must be typeof function');
        }

        if (element.offsetParent === null) {
            new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    const isVisible = entry.intersectionRatio === 1;

                    if(isVisible) {
                        callback(element);
                        observer.disconnect();
                    }
                });
            }).observe(element);
        }
    }

    return {
        fromString,
        filterByComponentDirectDescendants,
        getClosestMatchingParent,
        getDirectChildren,
        getNodeArrayFromString,
        isNode,
        isNodeList,
        isWebComponent,
        moveContentBetweenNodes,
        removeAllParentsChildren,
        removeNodes,
        runOnNodeVisible
    };

})();